import React from 'react';
import styled from 'styled-components';
import { LoadingOverlay } from '../../../components/LoadingSpinner';
import { Heading4 } from '../../../components/Typography';
import { PageContentProps } from '../models';

const s = {
  PageWrapper: styled.div`
    position: relative;
    max-width: 410px;
    box-sizing: border-box;
    padding-top: 50px;
    padding-bottom: 80px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 20px;
    padding-right: 20px;
  `,
  HeadingsWrapper: styled.div`
    margin-bottom: 34px;
  `,
  Heading1: styled(Heading4)`
    margin-top: 0;
    margin-bottom: 1em;
    font-size: 24px;
    font-weight: bold;
    line-height: 1.2;
  `,
  LoadingOverlayWrapper: styled.div`
    position: absolute;
    margin: 0 auto;
    left: -20px;
    right: -20px;
    bottom: 20px;
    top: 0;
  `,
  Content: styled.div`
    font-size: 20px;
    line-height: 1.2;
  `,
};

const PageContent: React.FC<PageContentProps> = (props) => {
  return (
    <s.PageWrapper>
      {props.isLoading && (
        <s.LoadingOverlayWrapper>
          <LoadingOverlay in={props.isLoading} />
        </s.LoadingOverlayWrapper>
      )}
      <s.HeadingsWrapper>
        <s.Heading1>{props.heading}</s.Heading1>
        {props.content && <s.Content>{props.content}</s.Content>}
      </s.HeadingsWrapper>
      {props.children}
    </s.PageWrapper>
  );
};

export default PageContent;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/auth/components/PageContent.tsx